import { useContext, useState, useEffect } from 'react';
import '../css/user/userdel.css';
import { Dimcontext } from '../../context/pagecontext';
import { Button, Form, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { MdClose, MdDeleteSweep, MdWarning } from 'react-icons/md';
import api from '../../api';
import { auth } from "../../firebase"
import Swal from 'sweetalert2';
import { ToastContainer } from 'react-toastify';
import { Datacontext } from '../../context/dataContext';
import { useNavigate } from 'react-router-dom';

export const Userdel = ({ set_del, id, showToast, userg }) => {
    const navigate = useNavigate()
    const { setDim } = useContext(Dimcontext);
    const { users } = useContext(Datacontext)
    const [userd, setuserd] = useState({ name: '' });
    const [confirmName, setConfirmName] = useState('');

    const handledelclose = () => {
        set_del(false);
        setDim(false);
    };

    

    useEffect(() => { 
        const getdel = async (id) => {
        const d = users.find(item => item.id === id);
            setuserd({ name: d?.name || '' });
    }; 
        getdel(id); }, [id, users]);

    const del = async (e) => {
        e.preventDefault();
        if (userd.name !== confirmName) return showToast("Name mismatch! Please type the name exactly.");
        
        try {
            await api.delete(`/delete_one_user/${id}`);
            Swal.fire({
                title: "Deleted!",
                text: "User has been permanently removed.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true
            });
            handledelclose();
            userg();
        } catch (err) {
            console.error(err); 
            if (err.response && err.response.status === 401) {
                showToast("Session expired. Attempting to refresh...");
                try {
                    // Force Firebase to get a fresh token
                    const freshToken = await auth.currentUser.getIdToken(true);
                    sessionStorage.setItem("token", freshToken);
                    // OPTIONAL: Retry the failed request with the freshToken
                    // return retryRequest(originalConfig, freshToken);
                } catch (refreshErr) {
                    // If refreshing fails, the user session is truly dead
                    showToast("Refresh failed. Logging out.");
                    navigate("/")
                    
                    // window.location.href = '/login'; 
                }
            } else {
                // Handle other types of errors (Network, 500, etc.)
                showToast("Something went wrong. Please try again.");
            }
        }
    };

    return (
        <div className="user-delete-card shadow-lg">
            <ToastContainer/>
            {/* Custom Header */}
            <div className="modal-header-custom delete-theme">
                <div className="header-title">
                    <MdDeleteSweep className="me-2" />
                    <span>Delete User Account</span>
                </div>
                <button onClick={handledelclose} className="btn-close-custom">
                    <MdClose />
                </button>
            </div>

            <div className="p-4">
                <div className="warning-box mb-4">
                    <MdWarning className="warning-icon" />
                    <div>
                        <strong>Warning:</strong> This action is permanent. To confirm, please type the user's name below.
                    </div>
                </div>

                <Form onSubmit={del}>
                    <FormGroup className="mb-4">
                        <FormLabel className="fw-bold text-muted">User to be Deleted</FormLabel>
                        <FormControl 
                            readOnly 
                            className="input-readonly-del"
                            value={userd.name} 
                        />
                    </FormGroup>

                    <FormGroup className="mb-4">
                        <FormLabel className="fw-bold">Confirm Name</FormLabel>
                        <FormControl 
                            required 
                            type="text"
                            value={confirmName} 
                            onChange={(e) => setConfirmName(e.target.value)} 
                            placeholder="Type name here..." 
                        />
                    </FormGroup>

                    <div className="d-flex gap-3 mt-4">
                        <Button variant="secondary" className="w-100 py-2" onClick={handledelclose}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="danger" className="w-100 py-2 btn-delete-submit">
                            Confirm Delete
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
};